import { render, staticRenderFns } from "./KuickPayCheckout.vue?vue&type=template&id=5aa63980&scoped=true"
import script from "./KuickPayCheckout.vue?vue&type=script&lang=js"
export * from "./KuickPayCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa63980",
  null
  
)

export default component.exports